module.exports = __webpack_public_path__ + "static/media/createYourOwn.ead06d44.webp";